<script setup lang="ts" name="PortCallsDetailsDocumentsTypeTag">
import { computed } from 'vue';

import { BASE_TAG_CONTRAST } from '~/constants';

import BaseTag from '~/components/BaseTag.vue';

import type { BaseTagContrastType, PortCallsDocumentType } from '~/types';

import { PORT_CALLS_DOCUMENT_TYPES } from '../constants/organisationPortCalls';

const { value } = defineProps<{
  value: PortCallsDocumentType;
}>();

const TYPE_TO_CONTRAST: Record<PortCallsDocumentType, BaseTagContrastType> = {
  [PORT_CALLS_DOCUMENT_TYPES.BOL]: BASE_TAG_CONTRAST.OCEAN_1,
  [PORT_CALLS_DOCUMENT_TYPES.SOF]: BASE_TAG_CONTRAST.PURPLE_1,
  [PORT_CALLS_DOCUMENT_TYPES.NOR]: BASE_TAG_CONTRAST.ORANGE_1,
  [PORT_CALLS_DOCUMENT_TYPES.MATES]: BASE_TAG_CONTRAST.INDIGO_1,
};

const TYPE_TO_TEXT: Record<PortCallsDocumentType, string> = {
  [PORT_CALLS_DOCUMENT_TYPES.BOL]: 'bill of lading',
  [PORT_CALLS_DOCUMENT_TYPES.SOF]: 'statement of facts',
  [PORT_CALLS_DOCUMENT_TYPES.NOR]: 'notice of readiness',
  [PORT_CALLS_DOCUMENT_TYPES.MATES]: 'mate’s receipt',
};

const tagVariant = computed(() => TYPE_TO_CONTRAST[value]);
const tagName = computed(() => TYPE_TO_TEXT[value]);
</script>

<template>
  <BaseTag :variant="tagVariant" :name="tagName" />
</template>
